/* global videojs:true */

// Register the plugin in videojs plugins space.
module.exports = function (youbora) {
  if (typeof videojs !== 'undefined') {
    videojs.plugin('youborabc', function (options) {
      if (typeof this.youborabcplugin === 'undefined') {
        // First call of the plugin inits the plugin.
        this.youborabcplugin = new youbora.Plugin(options,
          new youbora.adapters.BrightcoveVideojs5(this))
      } else {
        // Subsequent calls set options.
        this.youborabcplugin.setOptions(options)
      }
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/register-plugin.js
// module id = 28
// module chunks = 0